<template>
  <v-dialog v-model="state.visible" :persistent="state.persistent" max-width="420">
    <v-card>
      <v-card-title class="headline">{{ state.title }}</v-card-title>
      <v-card-text>
        <div class="confirm-message" v-html="state.message"></div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="justify-end">
        <v-btn v-if="state.mode==='confirm'" text @click="onCancel">{{ state.cancelText }}</v-btn>
        <v-btn :color="state.color" depressed @click="onConfirm">{{ state.confirmText }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  
</template>

<script>
import { confirmState } from '@/plugins/confirm'

export default {
  name: 'ConfirmDialog',
  data: () => ({
    state: confirmState,
  }),
  methods: {
    onConfirm() {
      if (this.state._resolve) this.state._resolve(true)
      this.close()
    },
    onCancel() {
      if (this.state._resolve) this.state._resolve(false)
      this.close()
    },
    close() {
      this.state.visible = false
      // reset minimal state; keep texts for potential transitions
      this.$nextTick(() => {
        this.state._resolve = null
      })
    },
  },
}
</script>

<style scoped>
.confirm-message {
  white-space: pre-wrap;
}
</style>
